import { render, staticRenderFns } from "./SubscriptionUsage.vue?vue&type=template&id=2d4b8bc0&"
import script from "./SubscriptionUsage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports